import { render } from "./CollectionTabs.vue?vue&type=template&id=43a59736&scoped=true&ts=true"
import script from "./CollectionTabs.vue?vue&type=script&lang=ts"
export * from "./CollectionTabs.vue?vue&type=script&lang=ts"

import "./CollectionTabs.vue?vue&type=style&index=0&id=43a59736&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a59736"]])

export default __exports__